
export class SclProjectionConstantService {

  static EPSG = {
    'EPSG:28355' : '+proj=utm +zone=55 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs',
    'EPSG:3111': '+proj=lcc +lat_1=-36 +lat_2=-38 +lat_0=-37 +lon_0=145 +x_0=2500000 +y_0=2500000 +ellps=GRS80 ' +
      '+towgs84=0,0,0,0,0,0,0 +units=m +no_defs', // update Aug-2019
    'EPSG:3857': '+proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m ' +
      '+nadgrids=@null +wktext  +no_defs',
    'EPSG:4326': '+proj=longlat +datum=WGS84 +no_defs',
    'EPSG:900913': '+proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 ' +
      '+units=m +nadgrids=@null +wktext  +no_defs'
  };
}
